import React from 'react'
import { IconButtonProps } from '@mui/material'
import HistoryIcon from '@mui/icons-material/History'
import { SquareButton } from '../../styles/ButtonStyles'
import { t } from 'i18next'

interface ToggleHistoryButtonProps extends IconButtonProps {
  isHistoryVisible: boolean
  setIsHistoryVisible: React.Dispatch<React.SetStateAction<boolean>>
  disabled: boolean
}

const ToggleHistoryButton: React.FC<ToggleHistoryButtonProps> = ({
  isHistoryVisible,
  setIsHistoryVisible,
  disabled,
}) => {
  return (
    <SquareButton
      disabled={disabled}
      color="secondary"
      onClick={() => setIsHistoryVisible(!isHistoryVisible)}
      aria-label={t('components.tooltip.scheduleModificationHistory')}
    >
      <HistoryIcon />
    </SquareButton>
  )
}

export default ToggleHistoryButton
